"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRefreshTokenDto = instanceOfRefreshTokenDto;
exports.RefreshTokenDtoFromJSON = RefreshTokenDtoFromJSON;
exports.RefreshTokenDtoFromJSONTyped = RefreshTokenDtoFromJSONTyped;
exports.RefreshTokenDtoToJSON = RefreshTokenDtoToJSON;
exports.RefreshTokenDtoToJSONTyped = RefreshTokenDtoToJSONTyped;
/**
 * Check if a given object implements the RefreshTokenDto interface.
 */
function instanceOfRefreshTokenDto(value) {
    if (!('accessToken' in value) || value['accessToken'] === undefined)
        return false;
    if (!('idToken' in value) || value['idToken'] === undefined)
        return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined)
        return false;
    return true;
}
function RefreshTokenDtoFromJSON(json) {
    return RefreshTokenDtoFromJSONTyped(json, false);
}
function RefreshTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accessToken': json['accessToken'],
        'idToken': json['idToken'],
        'refreshToken': json['refreshToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
    };
}
function RefreshTokenDtoToJSON(json) {
    return RefreshTokenDtoToJSONTyped(json, false);
}
function RefreshTokenDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accessToken': value['accessToken'],
        'idToken': value['idToken'],
        'refreshToken': value['refreshToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
    };
}
